import { tornadoActive } from '../state/app-state.js';

export interface TornadoHandlers {
  onToggle: (active: boolean) => void;
}

export function renderTornadoPanel(host: HTMLElement, h: TornadoHandlers): void {
  host.innerHTML = `
    <div class="panel">
      <h2>Tornado alert</h2>
      <div class="row">
        <button id="tp-toggle" class="button">Activate Tornado Warning</button>
        <span id="tp-state" hidden></span>
      </div>
    </div>`;
  const btn = host.querySelector<HTMLButtonElement>('#tp-toggle')!;
  const state = host.querySelector<HTMLSpanElement>('#tp-state')!;

  function render() {
    const on = tornadoActive.get();
    btn.textContent = on ? 'Clear Tornado Warning' : 'Activate Tornado Warning';
    btn.classList.toggle('is-active', on);
    btn.classList.toggle('is-danger', on);
    state.hidden = !on;
    state.textContent = on ? 'TORNADO ACTIVE' : '';
    state.className = on ? 'alert-chip' : '';
  }

  btn.addEventListener('click', () => {
    const next = !tornadoActive.get();
    tornadoActive.set(next);
    h.onToggle(next);
    render();
  });

  tornadoActive.subscribe(() => render());
}
